import { Component, input, inject, signal, effect } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { News, NewsService } from '../news.service';
import { ImagePreview } from '../news-image/news-image.component';

@Component({
  selector: 'app-news-item',
  imports: [DatePipe],
  templateUrl: './news-item.component.html',
  styleUrl: './news-item.component.css'
})
export class NewsItemComponent {
  private readonly router = inject(Router);
  private readonly newsService = inject(NewsService);

  readonly news = input.required<News>();
  readonly imagePreviews = signal<ImagePreview[]>([]);
  readonly isLoadingImages = signal(false);

  constructor() {
    effect(async () => {
      const currentNews = this.news();
      const newsImages = currentNews.newsImages;
      
      if (!newsImages?.length) {
        this.imagePreviews.set([]);
        this.isLoadingImages.set(false);
        return;
      }

      this.isLoadingImages.set(true);
      
      try {
        const imagesWithUrls = await this.newsService.getImagesWithMetadata(newsImages);
        this.imagePreviews.set(this.newsService.mapToImagePreviews(imagesWithUrls));
      } catch (error) {
        console.error('Error loading news images:', error);
        this.imagePreviews.set([]);
      } finally {
        this.isLoadingImages.set(false);
      }
    });
  }

  protected onEdit(): void {
    this.router.navigate(['/main/news', this.news().id]);
  }
}
